import styled from 'styled-components';
import { sizes } from 'style';

const H1 = styled.h1`
  font-size: 30px;
  margin: 0;
  line-height: 1;

  @media ${sizes.tabletPortrait} {
    font-size: 40px;
  }
`;

export default H1;
